import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Determines if a model instance has a trait that matches the name and type of one defined in
 * a {@link ModelTraits} class.
 *
 * @param model The model to check for presence of the trait.
 * @param TraitsClass The {@link ModelTraits} class containing the trait of interest.
 * @param trait1 The name of a trait of interest.
 * @param trait2 The name of a trait of interest.
 * @param trait3 The name of a trait of interest.
 * @param trait4 The name of a trait of interest.
 * @param trait5 The name of a trait of interest.
 * @returns True if the model contains traits matching the ones in `TraitsClass`; otherwise, false.
 *          Note that this function will return true for a matching name and type even if the model
 *          doesn't implement the particular traits class specified.
 */

function hasTraits(model, TraitsClass) {
  if (model === undefined || model.traits === undefined) {
    return false;
  }
  for (var _len = arguments.length, traits = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    traits[_key - 2] = arguments[_key];
  }
  for (const trait of traits) {
    const modelTrait = model.traits[trait];
    const traitsTrait = TraitsClass.traits[trait];
    if (modelTrait === undefined || traitsTrait === undefined) {
      return false;
    }
    if (!traitsTrait.isSameType(modelTrait)) {
      return false;
    }
  }
  return true;
}
export default hasTraits;